import { Stack } from '@mui/material';
import { ControlledDropdown } from 'Components/ControlledDropdown';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useContext, useEffect, useState } from 'react';
import { General } from '../TherapyFilter/General';
import { AllFilters } from '../AllFilters';
import { DoctorsSuppliersContext } from 'Context/SuppliersContext/DoctorsSuppliersContext';
import { Preferences } from './Preferences';
import { Gender } from './Gender';

export const DoctorFilter = () => {
  const { filters, suppliers } = useContext(DoctorsSuppliersContext);
  const [supplierChangeDetection, setSupplierChangeDetection] =
    useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);

  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage;

  useEffect(() => {
    setSupplierChangeDetection((prev) => !prev);
  }, [suppliers.filteredResults]);

  return (
    <Stack
      direction='row'
      gap='24px'
      sx={{
        width: 'fit-content',
        minHeight: '50px',
        flexWrap: 'wrap',
      }}
    >
      {isDesktop && (
        <>
          <ControlledDropdown
            label={dictionary.therapy.sort}
            filterComponent={<General />}
            activeFilters={
              (filters.orderByAscendingAlphabet ||
              filters.orderByDescendingAlphabet
                ? 1
                : 0) + (filters.location ? 1 : 0)
            }
            closeOnEffect={supplierChangeDetection}
          />
          <ControlledDropdown
            label={dictionary.preferences}
            filterComponent={<Preferences />}
            activeFilters={filters.accessible || filters.homeVisit ? 1 : 0}
            closeOnEffect={supplierChangeDetection}
          />
          <ControlledDropdown
            label={dictionary.gender}
            filterComponent={<Gender />}
            activeFilters={filters.gender ? 1 : 0}
            closeOnEffect={supplierChangeDetection}
          />
        </>
      )}
      <AllFilters openModal={openModal} setOpenModal={setOpenModal} />
    </Stack>
  );
};
